import config from '../../config';

export default {
  url: `${config.api.baseURL}/accounts/:id`,
  transformer(data) {
    return data;
  }
};
